import { PopoverNavigationItem } from '@spotify-internal/encore-web/core';
import React from 'react';

import { MastheadLink, MastheadLinkList } from 'lib/sanity/types';
import { isMastheadLinkList } from 'utils/type-guards';
import { ProfileLinkItem } from 'components/Masthead/Header/Profile/LinkItem';
import {
  NavBarProfileLinkListItemsWrapper,
  NavBarProfileLinkListTitle,
} from 'components/Masthead/Header/Profile/Shared';
import { isLinkDisabled, isLinkVisible } from 'components/Masthead/Header/Profile/utils';
import { UbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';

interface Props {
  item: MastheadLinkList | MastheadLink;
  isLoggedIn: boolean;
  ubi: UbiMastheadHeader;
}

export const ProfileNavigationItem = ({ item, isLoggedIn, ubi }: Props) => {
  const onProfileLinkClick = (identifier: string, uri: string) => {
    ubi.logProfileLinkInteraction({ container: 'header', identifier, uri });
  };

  return isMastheadLinkList(item) ? (
    <PopoverNavigationItem>
      <NavBarProfileLinkListTitle>{item.label}</NavBarProfileLinkListTitle>
      <NavBarProfileLinkListItemsWrapper>
        {item.entries
          .filter(({ link }) => isLinkVisible(link, isLoggedIn))
          .map(({ link, nestingLevel }, i) => (
            <ProfileLinkItem
              key={i}
              {...link}
              onClick={() => {
                onProfileLinkClick(link.trackingID, link.href);
              }}
              nestingLevel={nestingLevel}
              isDisabled={isLinkDisabled(link, isLoggedIn)}
            />
          ))}
      </NavBarProfileLinkListItemsWrapper>
    </PopoverNavigationItem>
  ) : (
    <ProfileLinkItem
      {...item}
      onClick={() => {
        onProfileLinkClick(item.trackingID, item.href);
      }}
      nestingLevel={1}
    />
  );
};
